// -----------------------
// Product Customizations
// -----------------------

// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

const cr = {
    variantsSelected: function(type){
        let variantSelectors;
        if (type === 'radio'){
            variantSelectors = document.querySelector('variant-radios');
            const fieldsets = variantSelectors.querySelectorAll('fieldset');
            let values = [];
            fieldsets.forEach(fieldset => {
                const inputs = fieldset.querySelectorAll('input');
                inputs.forEach(input => {
                    if (input.checked){
                        values.push(input.getAttribute('value'));
                    }

                });
            });
            return values;
        }
        if (type === 'select'){
            variantSelectors = document.querySelectorAll('variant-selects select');
            let values = [];
            variantSelectors.forEach(select => {
                const selectedOption = select.options[select.selectedIndex];
                values.push(selectedOption.value);
            });
            return values;
        }

    },
    updateSelectedPrice: function(variantsSelected){
        const compareAtPrice = parseInt(cr.matchingVariant(variants, variantsSelected)?.compare_at_price);
        let regularPrice = parseInt(cr.matchingVariant(variants, variantsSelected)?.price);
        const priceSaleElement = document.querySelector('.price__container');
        const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
        let compareElement = priceSaleElement.querySelector('.price-item--regular');

        if (window.Rebuy?.Cart) {
            // let Rebuy format the money
            if (compareAtPrice) {
                compareElement.innerHTML = window.Rebuy.Cart.formatMoney(compareAtPrice).replace(/^([a-zA-Z]+)(\d+)/, "$1 $2");
            } else {
                compareElement.innerHTML = '';
            }
            salePriceElement.innerHTML = window.Rebuy.Cart.formatMoney(regularPrice).replace(/^([a-zA-Z]+)(\d+)/, "$1 $2");
        } else {
            // fallback which uses currency code instead of its symbol
            let currency = window.Shopify.currency.active
            if (currency.length > 1) {
                currency = `${currency} `
            }

            if (compareAtPrice) compareElement.innerHTML = currency + compareAtPrice / 100;
            salePriceElement.innerHTML = currency + regularPrice / 100;
        }
    },
    variantsOnChange: function(type){
        let selectors;
        if (type === 'radio'){
            selectors = document.querySelectorAll('.product-form__input input[type="radio"]');
        }
        if (type === 'select'){
            selectors = document.querySelectorAll('.product-form__input select');
        }

        selectors.forEach(selector => {
            selector.addEventListener('change', event => {
                // Update Product Photo
                if (cr.matchingVariant(variants, cr.variantsSelected(type))?.featured_media?.preview_image?.src) {
                    cr.updateProductPhoto(cr.matchingVariant(variants, cr.variantsSelected(type)).featured_media.preview_image.src);
                }
                document.querySelector('input.product-variant-id').value = cr.matchingVariant(variants, cr.variantsSelected(type))?.id;
                cr.updateSelectedPrice(cr.variantsSelected(type));
                cr.updateAvailabilityDisplay(cr.variantsSelected(type))
                cr.numberOfItemsInStock(cr.variantsSelected(type));

                cr.updateVariantAvailability(event);
            });
            
            cr.updateVariantAvailability();
            cr.numberOfItemsInStock(cr.variantsSelected(type));
        });
    },
    matchingVariant: function(variants, variantsSelected) {
        return variants.find(variant => {
            return variant.options.every((option, index) => {
                return option === variantsSelected[index];
            });
        });
    },
    updateProductPhoto: function(imageUrl){
        // Find slide with matching src
        const slickSlides = document.querySelectorAll('.slick-slide');
        slickSlides.forEach(slide => {
            const img = slide.querySelector('img');
            if (img) {
                const imgSrc = img.getAttribute('src');
                const protocolRemovedSrc = imageUrl.replace('https:', '');
                if (imgSrc === protocolRemovedSrc) {
                    let slideIndex = slide.getAttribute('data-slick-index');
                    // Use slickGoTo to go to that slide
                    $('.product-thumbs').find('.js-slider-thumbs').slick('slickGoTo', slideIndex);
                }
            }
        });
    },
    quantityChange: function(){
        const minButton = document.querySelector('.quantity-form .min');
        const plusButton = document.querySelector('.quantity-form .plus');
        const quantityInput = document.getElementById('Quantity');

        minButton.addEventListener('click', event => {
            event.preventDefault();
            let quantity = parseInt(quantityInput.value);
            if (quantity > 1) {
                quantity--;
                quantityInput.value = quantity;
            }
        });
        plusButton.addEventListener('click', event => {
            event.preventDefault();
            let quantity = parseInt(quantityInput.value);
            quantity++;
            quantityInput.value = quantity;
        });
    },
    numberOfItemsInStock: function(variantsSelected){
        const matchingVariant = cr.matchingVariant(variants, variantsSelected)
        let variantQuantity = document.getElementById("variant-quantity")
        const iconInventory = document.querySelector('.icon--inventory')

        iconInventory.classList.remove('icon--inventory--in-stock')
        iconInventory.classList.remove('icon--inventory--oos')
        iconInventory.classList.remove('icon--inventory--low-on-stock')

        if (matchingVariant?.quantity < 1 || matchingVariant === undefined) {
            variantQuantity.textContent = "We are currently out of stock"

            iconInventory.classList.add('icon--inventory--oos')
        }

        if (matchingVariant?.available) {
            if (matchingVariant?.quantity > 0 && matchingVariant?.quantity < 10) {
                variantQuantity.textContent = `Low on stock - ${matchingVariant?.quantity} available`

                iconInventory.classList.add('icon--inventory--low-on-stock')

            } else if (matchingVariant?.quantity >= 10) {
                variantQuantity.textContent = `Item is in stock`
                
                iconInventory.classList.add('icon--inventory--in-stock')
            } 
        }
    },
    updateVariantAvailability: function(event) {
        var selectedOptions = {};
        const variantRadios = document.querySelectorAll('.product-form__input input[type="radio"]');
        variantRadios.forEach(radio => {
            radio.classList.remove('variant-option--out-of-stock');
            
            if (radio.checked) {
                selectedOptions[radio.name] = radio.value;
            }
        });

        // variantRadios.forEach(radio => {
        //     const variantValue = radio.value;
        //     const matchingVariant = variants.find(variant => variant.options.includes(variantValue));
        //     if (matchingVariant && !matchingVariant.available) {
        //         radio.classList.add('variant-option--out-of-stock');
        //     }
        // });

        const variantSelects = document.querySelectorAll('.product-form__input select');
        variantSelects.forEach(select => {
            const options = select.querySelectorAll('option');
            options.forEach(option => {
                option.classList.remove('variant-option--out-of-stock');
            });

            if (!!select.value) {
                selectedOptions[select.name] = select.value;
            }

            // options.forEach(option => {
            //     const variantValue = option.value;
            //     const matchingVariant = variants.find(variant => variant.options.includes(variantValue));
            //     if (matchingVariant && !matchingVariant.available) {
            //         option.classList.add('variant-option--out-of-stock');
            //     }
            // });
        });

        // const selectedVariantTitle = Object.values(selectedOptions).join(" / ");
        // const matchingVariant = variants.find(variant => variant.title == selectedVariantTitle);
    },
    updateAvailabilityDisplay: function (variantsSelected) {
        const matchingVariant = cr.matchingVariant(variants, variantsSelected)

        if (matchingVariant?.available) {
            document.querySelector(".js-go-cart-add-to-cart").removeAttribute("disabled")
            document.querySelector(".js-go-cart-add-to-cart").innerHTML = "ADD TO CART"
            Array.from(document.querySelector(".js-qty__wrapper").children).forEach(v => {
                v.removeAttribute("disabled");
            })
            document.querySelector(".js-qty__wrapper input").setAttribute("max", `${matchingVariant.inventory_quantity}`)
            let currentValue = document.querySelector(".js-qty__wrapper input").value
            if (currentValue > matchingVariant.inventory_quantity) {
                document.querySelector(".js-qty__wrapper input").value = matchingVariant.inventory_quantity
            }
        } else {
            document.querySelector(".js-go-cart-add-to-cart").setAttribute("disabled", "disabled")
            document.querySelector(".js-go-cart-add-to-cart").innerHTML = "SOLD OUT"
            Array.from(document.querySelector(".js-qty__wrapper").children).forEach(v => {
                v.setAttribute("disabled", "")
            })
            document.querySelector(".js-qty__wrapper input").setAttribute("max", "1")
        }
    }
}

// Page is Ready
documentReady(function() {
    // Variant Radios
    if ( document.querySelector('variant-radios') !== null ){
        // Detect changes to radio buttons
        cr.variantsOnChange('radio');
    }

    // Variant Selects
    if ( document.querySelector('variant-selects') !== null ){
        // Detect changes to select elements
        cr.variantsOnChange('select');
    }

    // Quantity Change
    cr.quantityChange();
});
